import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class GoModal extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  @Prop({ type: String, required: false }) dialogClass!: string;
  @Prop({ type: String, required: false }) id!: string;
  @Prop({ type: String, required: false }) modalClass!: string;
  @Prop({ type: Boolean, default: false, required: false }) hideFooter!: boolean;
  @Prop({ type: Boolean, default: false, required: false }) hideHeader!: boolean;
  @Prop({ type: Boolean, default: false, required: false }) noCloseOnBackdrop!: boolean;
  @Prop({ type: Boolean, default: true, required: false }) centered!: boolean;

  @Emit('modal:close') close() {}

  @Emit('modal:ok') ok(payload: any) {}
}
